module.exports = {
  NO_MOVEMENTS_FOUND: 'PCE001',
  PIX_KEY_NOT_FOUND: 'PBE304',
  WITHOUT_BALANCE: 'PBE105',
  ENTRY_KEY_OWNED_BY_DIFFERENT_PERSON: 'PBE364',
  ENTRY_KEY_IN_CUSTODY_OF_DIFFERENT_PARTICIPANT: 'PBE365',
  ENTRY_LOCKED_BY_CLAIM: 'PBE367',
  CLAIM_ALREADY_EXISTS_FOR_KEY: 'PBE372',
  ABORTED_SETTLEMENT_TIMEOUT: 'PBE324',
  ERROR_CREDITOR_AGENT: 'PBE325',
  ORDER_REJECTED: 'PBE339',
  SETTLEMENT_FAILED: 'PBE343',
  GENERAL_REJECT_OPERATION: 'PBE100'
};
